import { storeToRefs, navigateTo, useAsyncData, useNuxtApp, showError } from '#imports';
import { usePageStore } from '~dsc/stores/cms/page';
import { httpStatus } from '~dsc/utils/http-status';

export const usePageLoad = async (route, prefix = 'page') => {
    const { $i18n } = useNuxtApp();
    const { pageBuffer } = storeToRefs(usePageStore());

    if (route.name !== `url___${$i18n.defaultLocale}` && $i18n.strategy === 'no_prefix') {
        return false;
    }

    const { error } = await useAsyncData(`${prefix}-${route.path.replace(/\//, '-')}`, () => usePageStore().pageLoad(route));
    if (error.value) {
        throw showError(error.value);
    }

    if (import.meta.client) {
        const content = pageBuffer.value;
        const redirect = content.find(block => block.contentType === 'cardList' && block.display?.component === 'redirect');

        if (redirect && redirect.display?.url) {
            navigateTo(redirect.display.url, {
                redirectCode: httpStatus.TEMPORARY_REDIRECT,
                external: /^https?:\/\//.test(redirect.display.url),
            });
        }
    }
};
